export const REFRESH_USER = 'refresh_user';
/* -------------------- Demo ------------------*/
export const DEMO_CLAIM = 'demo_claim';

export const DEMO_CLAIM_SERVICES_SUCCESS = 'demo_claim_success_success';
export const DEMO_CLAIM_SERVICES_FAIL = 'demo_claim_success_fail';

export const DEMO_DEPENDANT_ADD = 'demo_dependant_add';
export const DEMO_DEPENDANT_REMOVE = 'demo_dependant_remove';

export const DEMO_PATIENT_ADD = 'demo_patient_add';
export const DEMO_PATIENT_REMOVE = 'demo_patient_remove';

export const DEMO_UPDATE_PERSONAL = 'demo_update_personal';

export const DEMO_CLAIM_ITEM_ADD = 'demo_claim_item_add';
export const DEMO_CLAIM_ITEM_ADD_SUCCESS = 'demo_claim_item_add_success';
export const DEMO_CLAIM_ITEM_ADD_FAIL = 'demo_claim_item_add_fail';

export const DEMO_CLAIM_ITEM_REMOVE = "demo_claim_item_remove";
export const DEMO_CLAIM_ITEM_REMOVE_SUCCESS = "demo_claim_item_remove_success";

export const DEMO_LOGIN_FAIL = "demo_login_fail";
export const DEMO_LOGIN_SUCCESS = "demo_login_success";

export const DEMO_CLAIM_SUBMIT = "demo_claim_submit";
export const DEMO_CLAIM_SUBMIT_FAIL = "demo_claim_submit_fail";
export const DEMO_CLAIM_SUBMIT_SUCCESS = "demo_claim_submit_success";

export const DEMO_SET_FIELD = 'demo_set_field';
export const DEMO_MERGE_FIELD = 'demo_merge_field';

export const DEMO_CLAIM_ITEM_CLEAR = 'demo_claim_item_clear';

export const DEMO_CLEAR = 'demo_clear';

/* -------------------- General ------------------*/
export const TEXT_FIELD_CHANGED = 'text_field_changed';
export const LOADED = 'loaded';
export const LOGOUT = 'log_out';
export const SET_LOADING = 'set_loading';
export const ERROR_CLEAR = 'error_clear';

export const LOG_CLIENT_ERRORS = 'log_client_errors';
export const LOG_CLIENT_ERRORS_SUCCESS = 'log_client_errors_success';
export const LOG_CLIENT_ERRORS_FAIL = 'log_client_errors_fail';

export const GENERAL_PREFERENCE_FIELD_CHANGED = 'general_preference_field_changed';
export const GENERAL_REQUEST_LOADING = 'general_request_loading';
export const GENERAL_REQUEST_LOADED = 'general_request_loaded';
export const SAVE_PREFERENCE = 'save_preference';
export const SET_PREFERENCE = 'set_preference';

export const GENERAL_SWITCH_THEME = "general_switch_theme";

export const GENERAL_UPDATE_LIST_SET = "tools_update_append_set";
export const GENERAL_UPDATE_LIST_APPEND = "tools_update_append_list";
export const GENERAL_UPDATE_LIST_APPEND_FAIL = "tools_update_append_list_fail";
export const GENERAL_UPDATE_LIST_APPEND_SUCCESS = "tools_update_append_list_success";

export const SET_GENERAL_FIELD = 'set_general_field';
export const SET_GENERAL_ERRORS = 'set_general_errors';
export const SET_GENERAL_SNACKBAR = 'set_general_snackbar';

export const SET_NOTIFICATIONS = 'set_notifications';
export const APPEND_NOTIFICATIONS = 'append_notifications';
export const DISMISS_NOTIFICATION = 'dismiss_notification';
export const CLEAR_NOTIFICATIONS = 'clear_notifications';

export const GENERAL_SET_PUSH_REDIRECT = 'general_set_push_redirect';
export const GENERAL_SET_SELECTED_NOTIFICATION = 'general_set_selected_notification';
export const GENERAL_CLEAR_PUSH_REDIRECT = 'general_clear_push_redirect';

export const SET_CLIENT_VERSION = 'set_client_version';

export const SNACKBAR_SET = 'snackbar_set';
export const SNACKBAR_RESET = 'snackbar_reset';

export const MODAL_FORM_SET = 'modal_form_set';
export const MODAL_FORM_SET_COMPONENT = 'modal_form_set_component';
export const MODAL_FORM_RESET = 'modal_form_reset';
export const MODAL_FORM_TOGGLE = 'modal_form_toggle';

export const FEEDBACK_SUBMIT = 'feedback_submit';
export const FEEDBACK_SUBMIT_FAILED = 'feedback_submit_failed';
export const FEEDBACK_SUBMIT_SUCCESS = 'feedback_submit_success';

/* -------------------- Login ------------------*/
export const LOGIN = 'login';
export const LOGIN_SUCCESS = 'login_success';
export const LOGIN_FAIL = 'login_fail';

export const PARTNER_LOGIN_SUCCESS = 'partner_login_success';
export const PARTNER_LOGIN_FAIL = 'partner_login_fail';

export const SET_USER_TYPE = 'set_user_type';

/* -------------------- Password Reset / Update ------------------*/
export const RESET_PASSWORD_FAIL = 'reset_password_fail';
export const RESET_PASSWORD_SUCCESS = 'reset_password_SUCCESS';
export const RESET_PASSWORD = 'reset_password';
export const SET_PASSWORD_HASH = 'set_password_hash';
export const NEW_PASSWORD_SET = 'new_password_set';
export const NEW_PASSWORD_SET_FAIL = 'new_password_set_fail';
export const NEW_PASSWORD_SET_SUCCESS = 'new_password_set_success';

/* -------------------- Tools ------------------*/
export const LOGIN_TOOLS = 'login_tools';

export const LOGIN_TOOLS_SUCCESS = 'login_tools_success';
export const LOGIN_TOOLS_FAIL = 'login_tools_fail';

export const LOGIN_TOOLS_PARTNER_SUCCESS = 'login_tools_partner_success';
export const LOGIN_TOOLS_PARTNER_FAIL = 'login_tools_partner_fail';

export const LOGOUT_TOOLS = 'log_out_tools';

export const AUTH_TOOLS_TOKEN_EXPIRY = 'auth_tools_token_expiry';

export const TOOLS_ACCESS_USER_ACCOUNT_FAIL = 'tools_access_user_account_fail';
export const TOOLS_ACCESS_USER_ACCOUNT_SUCCESS = 'tools_access_user_account_success';

export const TOOLS_ACCESS_PARTNER_ACCOUNT_FAIL = 'tools_access_partner_account_fail';
export const TOOLS_ACCESS_PARTNER_ACCOUNT_SUCCESS = 'tools_access_partner_account_success';

export const TOOLS_HSA_SALES_FAIL = "tools_hsa_sales_fail";
export const TOOLS_HSA_SALES_SUCCESS = "tools_hsa_sales_success";

export const TOOLS_HSA_ROUTES_FAIL = "tools_hsa_routes_fail";
export const TOOLS_HSA_ROUTES_SUCCESS = "tools_hsa_routes_success";

export const TOOLS_HSA_GENERAL_FAIL = "tools_hsa_general_fail";
export const TOOLS_HSA_GENERAL_SUCCESS = "tools_hsa_general_success";

export const TOOLS_HSA_TRANSFER_FAIL = "tools_hsa_transfer_fail";
export const TOOLS_HSA_TRANSFER_SUCCESS = "tools_hsa_transfer_success";

export const TOOLS_AUDIT_CLAIMS_FAIL = "tools_audit_claims_fail";
export const TOOLS_AUDIT_CLAIMS_SUCCESS = "tools_audit_claims_success";

export const TOOLS_AUDIT_CLAIM_DETAILS_FAIL = "tools_audit_claim_details_fail";
export const TOOLS_AUDIT_CLAIM_DETAILS_SUCCESS = "tools_audit_claim_details_success";

export const TOOLS_AUDIT_CLAIM_DETAILS_PASS_SUCCESS = "tools_audit_claim_details_pass_success";

export const TOOLS_AUDIT_PADS_FAIL = 'tools_audit_pads_fail';
export const TOOLS_AUDIT_PADS_SUCCESS = 'tools_audit_pads_success';

export const TOOLS_AUDIT_PAD_DETAILS_FAIL = 'tools_audit_pad_details_fail';
export const TOOLS_AUDIT_PAD_DETAILS_SUCCESS = 'tools_audit_pad_details_success';

export const REPORT_PAD_APPEND_DATA = 'report_pad_append_data';
export const REPORT_PAD_SET_DATA = 'report_pad_set_data';
export const REPORT_PAD_REMOVE_DATA = 'report_pad_remove_data';

export const TOOLS_FIELD_CHANGED = 'tools_field_changed';

export const TOOLS_API_TEST_FAIL = 'tools_api_test_fail';
export const TOOLS_API_TEST_SUCCESS = 'tools_api_test_success';

export const TOOLS_AD_MANAGE_FAIL = 'tools_ad_manage_fail';
export const TOOLS_AD_MANAGE_SUCCESS = 'tools_ad_manage_success';

export const TOOLS_AD_LIST_FAIL = "tools_ad_list_fail";
export const TOOLS_AD_LIST_SUCCESS = "tools_ad_list_success";

export const TOOLS_UPDATE_LIST_FAIL = "tools_update_list_fail";
export const TOOLS_UPDATE_LIST_SUCCESS = "tools_update_list_success";

export const TOOLS_UPDATE_ITEM_FAIL = "tools_update_item_fail";
export const TOOLS_UPDATE_ITEM_SUCCESS = "tools_update_item_success";

export const TOOLS_REMOVE_UPDATE_ITEM_FAIL = "tools_remove_update_item_fail";
export const TOOLS_REMOVE_UPDATE_ITEM_SUCCESS = "tools_remove_update_item_success";

export const TOOLS_UPDATE_LIST_APPEND_FAIL = "tools_update_append_list_fail";
export const TOOLS_UPDATE_LIST_APPEND_SUCCESS = "tools_update_append_list_success";

/* ---------------------- User  ---------------------*/
export const AUTH_USER_UPDATE_SUCCESS_MERGE = 'auth_user_update_success_merge';
export const AUTH_USER_TOKEN_EXPIRY = 'auth_user_token_expiry';

/* --------------- Employee / Profile ------------------*/
export const EMPLOYEE_LOADING = 'employee_loading';
export const EMPLOYEE_API_SUCCESS = 'employee_api_success';
export const EMPLOYEE_FIELD_CHANGED = 'employee_field_changed';
export const EMPLOYEE_DATA_CHANGED = 'employee_data_changed'
export const EMPLOYEE_VERIFY = 'employee_verify';
export const EMPLOYEE_UPDATE = 'employee_update';
export const EMPLOYEE_UPDATE_FAIL = 'employee_update_fail';
export const EMPLOYEE_UPDATE_SUCCESS = 'employee_update_success';
export const EMPLOYEE_TERMINATE = 'employee_terminate';
export const EMPLOYEE_TERMINATE_FAIL = 'employee_terminate_fail';
export const EMPLOYEE_TERMINATE_SUCCESS = 'employee_terminate_success';
export const EMPLOYEE_AGREEMENT = 'employee_agreement';
export const EMPLOYEE_AGREEMENT_FAIL = 'employee_agreement_fail';
export const EMPLOYEE_AGREEMENT_SUCCESS = 'employee_agreement_success';
export const AUTH_EMPLOYEE = 'auth_employee';
export const AUTH_EMPLOYEE_FAIL = 'auth_employee_fail';
export const AUTH_EMPLOYEE_SUCCESS = 'auth_employee_success';
export const EMPLOYEE_PRINT_CLAIM_SUCCESS = 'employee_print_claim_success';

export const EMPLOYEE_GET_BANKING_SUCCESS = 'employee_get_banking_success';
export const EMPLOYEE_SET_BANKING_SUCCESS = "employee_set_banking_success";

export const EMPLOYEE_BANKING_IMAGE_ADD = 'employee_banking_image_add';
export const EMPLOYEE_BANKING_IMAGE_ADD_SUCCESS = 'employee_banking_image_add_success';
export const EMPLOYEE_BANKING_IMAGE_ADD_FAILED = 'employee_banking_image_add_failed';
export const EMPLOYEE_BANKING_IMAGE_RESET = 'employee_banking_image_reset';

export const EMPLOYEE_DEPENDANT_EDIT = 'employee_dependent_edit';
export const EMPLOYEE_DEPENDANT_ADD = 'employee_dependent_add';
export const EMPLOYEE_DEPENDANT_DELETE = 'employee_dependent_delete';
export const EMPLOYEE_DEPENDANT_EXTEND = 'employee_dependent_extend';

export const EMPLOYEE_DEPENDANT_SUCCESS = 'employee_dependant_success';
export const EMPLOYEE_DEPENDANT_FAIL = 'employee_dependant_fail';

/* -------------- Benefit Coordinator -----------------*/
export const AUTH_BENEFIT_COORDINATOR = 'auth_benefit_coordinator';
export const AUTH_BENEFIT_COORDINATOR_FAIL = 'auth_benefit_coordinator_fail';
export const AUTH_BENEFIT_COORDINATOR_SUCCESS = 'auth_benefit_coordinator_success';

/* --------------- Employer / Profile ------------------*/
export const AUTH_EMPLOYER = 'auth_employer';
export const AUTH_EMPLOYER_FAIL = 'auth_employer_fail';
export const AUTH_EMPLOYER_SUCCESS = 'auth_employer_success';

export const EMPLOYER_SET_DATA = 'employer_set_data';
export const EMPLOYER_FIELD_CHANGED = 'employer_field_changed';

export const EMPLOYER_GET_PLAN_DETAILS = 'employer_get_plan_details';
export const EMPLOYER_GET_PLAN_DETAILS_SUCCESS = 'employer_get_plan_details_success';
export const EMPLOYER_GET_PLAN_DETAILS_FAIL = 'employer_get_plan_details_fail';
export const EMPLOYER_SET_ERRORS = 'employer_set_errors';

export const EMPLOYER_GET_FUNDING_DETAILS = 'employer_get_funding_details';
export const EMPLOYER_GET_FUNDING_DETAILS_SUCCESS = 'employer_get_funding_details_success';
export const EMPLOYER_GET_FUNDING_DETAILS_FAIL = 'employer_get_funding_details_fail';

export const EMPLOYER_BANKING_IMAGE_ADD = 'employer_banking_image_add';
export const EMPLOYER_BANKING_IMAGE_ADD_SUCCESS = 'employer_banking_image_add_success';
export const EMPLOYER_BANKING_IMAGE_ADD_FAILED = 'employer_banking_image_add_failed';
export const EMPLOYER_BANKING_IMAGE_RESET = 'employer_banking_image_reset';

export const EMPLOYER_GET_BANKING_SUCCESS = 'employer_get_banking_success';
export const EMPLOYER_SET_BANKING_SUCCESS = "employer_set_banking_success";

export const EMPLOYER_INSURANCE_FUNDING_SUCCESS = "employer_insurance_funding_success";
export const EMPLOYER_INSURANCE_FUNDING_FAIL = "employer_insurance_funding_fail";

export const EMPLOYER_REFUND_BALANCE_SUCCESS = 'employer_refund_balance_success';
export const EMPLOYER_REFUND_BALANCE_FAIL = 'employer_refund_balance_fail';

export const EMPLOYER_UPDATE = 'employer_update';
export const EMPLOYER_UPDATE_FAIL = 'employer_update_fail';
export const EMPLOYER_UPDATE_SUCCESS = 'employer_update_success';

export const EMPLOYER_ENABLE_ONLINE_SUCCESS = 'employer_enable_online_success';
export const EMPLOYER_ENABLE_ONLINE_FAIL = 'employer_enable_online_fail';

/* ------------- Employer Terminate ----------------*/
export const EMPLOYER_TERMINATE = 'employer_terminate';
export const EMPLOYER_TERMINATE_FAIL = 'employer_terminate_fail';
export const EMPLOYER_TERMINATE_SUCCESS = 'employer_terminate_success';

/* ------------- Employer Add ----------------*/
export const EMPLOYER_NEW_EMPLOYEE_REMOVE = 'employer_new_employee_remove';
export const EMPLOYER_NEW_EMPLOYEE_REMOVE_SUCCESS = 'employer_new_employee_remove_success';
export const EMPLOYER_NEW_EMPLOYEE_ADD = 'employer_new_employee_add';
export const EMPLOYER_NEW_EMPLOYEE_ADD_SUCCESS = 'employer_new_employee_add_success';

export const EMPLOYER_EMPLOYEES_ADD_SUCCESS = 'employer_employees_add_success';
export const EMPLOYER_EMPLOYEES_ADD_FAIL = 'employer_employees_add_fail';

/* ------------- Employee Changes ----------------*/

export const EMPLOYER_PENDING_EMPLOYEE_CLASS_CHANGE_SUCCESS = 'employer_pending_employee_class_change_success';
export const EMPLOYER_PENDING_EMPLOYEE_ONE_TIME_CHANGE_SUCCESS = 'employer_pending_employee_one_time_change_success';
export const EMPLOYER_NON_PLAN_ADMIN_CHANGE_SUCCESS = 'employer_non_plan_admin_change_success';

/* ------------- Active Employees / Directory ----------------*/
export const EMPLOYER_EMPLOYEE_DIRECTORY = 'employer_employee_directory';
export const EMPLOYER_EMPLOYEE_DIRECTORY_FAIL = 'employer_employee_directory_fail';
export const EMPLOYER_EMPLOYEE_DIRECTORY_SUCCESS = 'employer_employee_directory_success';

export const EMPLOYER_EMPLOYEE_LIST_SUCCESS = 'employer_employee_list_success';

/* ------------------- Active Division -----------------------*/
export const AUTH_DIVISION_DIRECTORY = 'auth_division_directory';
export const EMPLOYER_DIVISION_LIST_SUCCESS = 'employer_division_list_success';

/* ------------- Active Classification / Directory ----------------*/
export const AUTH_CLASSIFICATION_DIRECTORY = 'auth_classification_directory';
export const AUTH_CLASSIFICATION_DIRECTORY_FAIL = 'auth_classification_directory_fail';
export const AUTH_CLASSIFICATION_DIRECTORY_SUCCESS = 'auth_classification_directory_success';

export const AUTH_CLASSIFICATION_EDIT = 'auth_classification_edit';
export const AUTH_CLASSIFICATION_DELETE_PENDING = 'auth_classification_delete_pending';
export const AUTH_CLASSIFICATION_ADD = 'auth_classification_add';
export const AUTH_CLASSIFICATION_DELETE = 'auth_classification_delete';

/* ------------- Actions Wellness / Directory ----------------*/
export const EMPLOYER_WELLNESS_SETUP_SUCCESS = 'employer_wellness_setup_success';
export const EMPLOYER_WELLNESS_SETUP_FAIL = 'employer_wellness_setup_fail';

export const EMPLOYER_WELLNESS_DIRECTORY_SUCCESS = 'employer_wellness_directory_success';
export const EMPLOYER_WELLNESS_DIRECTORY_FAIL = 'employer_wellness_directory_fail';

export const EMPLOYER_WELLNESS_MANAGE_SUCCESS = 'employer_wellness_directory_success';
export const EMPLOYER_WELLNESS_MANAGE_FAIL = 'employer_wellness_directory_fail';

export const EMPLOYER_WELLNESS_TERMINATE_SUCCESS = 'employer_wellness_terminate_success';
export const EMPLOYER_WELLNESS_TERMINATE_FAIL = 'employer_wellness_terminate_fail';

/* --------------- Partner / Clients ------------------*/
export const PARTNER_SET_LOADING = 'parter_set_loading';

export const PARTNER_UPDATE_DATA = 'partner_update_data';
export const AUTH_PARTNER_FAIL = 'auth_partner_fail';

export const PARTNER_GET_BANKING_SUCCESS = 'partner_get_banking_success';
export const PARTNER_SET_BANKING_SUCCESS = 'partner_set_banking_success';

export const PARTNER_UPDATE_ASSISTANT_FAIL = 'partner_update_assistant_fail';
export const PARTNER_UPDATE_ASSISTANT_SUCCESS = 'partner_update_assistant_success';

export const PARTNER_UPDATE_WEB_FAIL = 'partner_update_web_fail';
export const PARTNER_UPDATE_WEB_SUCCESS = 'partner_update_web_success';

export const PARTNER_GET_CLIENTLIST = 'partner_get_clientlist';
export const PARTNER_GET_CLIENTLIST_SUCCESS = 'partner_get_clientlist_success';
export const PARTNER_GET_CLIENTLIST_FAIL = 'partner_set_clientlist_fail';

export const PARTNER_GET_AGENTLIST = 'partner_get_agentlist';
export const PARTNER_GET_AGENTLIST_SUCCESS = 'partner_get_agentlist_success';
export const PARTNER_GET_AGENTLIST_FAIL = 'partner_get_agentlist_fail';

export const PARTNER_GET_CLIENTDETAILS = 'partner_get_clientdetails';
export const PARTNER_GET_CLIENTDETAILS_SUCCESS = 'partner_get_clientdetails_success';
export const PARTNER_GET_CLIENTDETAILS_FAIL = 'partner_set_clientdetails_fail';

export const PARTNER_GET_AGENT_SUCCESS = 'partner_get_agent_success';
export const PARTNER_GET_AGENT_FAIL = 'partner_get_agent_fail';

export const PARTNER_GET_COMMISSIONS = 'partner_get_commissions';
export const PARTNER_GET_COMMISSIONS_SUCCESS = 'partner_get_commissions_success';
export const PARTNER_GET_COMMISSIONS_FAIL = 'partner_set_commissions_fail';

export const PARTNER_GET_HSA_SALES = 'partner_get_hsa_sales';
export const PARTNER_GET_HSA_SALES_SUCCESS = 'partner_get_hsa_sales_success';
export const PARTNER_GET_HSA_SALES_FAIL = 'partner_set_hsa_sales_fail';

export const PARTNER_SET_PERSONAL_DATA = 'partner_set_personal_data';
export const PARTNER_SET_WEB_DATA = 'partner_set_web_data';

export const PARTNER_BANKING_IMAGE_ADD = 'partner_banking_image_add';
export const PARTNER_BANKING_IMAGE_ADD_SUCCESS = 'partner_banking_image_add_success';
export const PARTNER_BANKING_IMAGE_ADD_FAILED = 'partner_banking_image_add_failed';
export const PARTNER_BANKING_IMAGE_RESET = 'partner_banking_image_reset';

/* -------------------- Signup ------------------*/
export const RESUME_APPLICATION = 'resume_application';
export const RESUME_APPLICATION_SUCCESS = 'resume_application_success';
export const RESUME_APPLICATION_START = 'resume_application_start';
export const RESUME_APPLICATION_FAIL = 'resume_application_fail';

export const SAVE_APPLICATION = 'save_application';
export const SAVE_APPLICATION_START = 'save_application_start';
export const SAVE_APPLICATION_SUCCESS = 'save_application_success';
export const SAVE_APPLICATION_FAIL = 'save_application_fail';

export const PARTNER_INSURANCE = "partner_insurance";
export const PARTNER_INSURANCE_SUCCESS = 'partner_insurance_success';
export const PARTNER_INSURANCE_FAIL = 'partner_insurance_fail';

export const PROCESS_APPLICATION = 'process_application';
export const PROCESS_APPLICATION_START = 'process_application_start';
export const PROCESS_APPLICATION_SUCCESS = 'process_application_success';
export const PROCESS_APPLICATION_FAIL = 'process_application_fail';

export const SIGNUP_APPLICATION_STRIPE_LOADING = 'signup_application_stripe_loading';
export const SIGNUP_APPLICATION_STRIPE_FAILED = 'signup_application_stripe_failed';
export const SIGNUP_APPLICATION_STRIPE_ACTION_REQUIRED = 'signup_application_stripe_action_required';

export const UPDATE_APPLICATION_FIELD = 'update_application_field';
export const UPDATE_APPLICATION_DATA = 'update_application_data';

export const INVALIDATE_APPLICATION = 'invalidate_application';

/* ---------------- Employer Stripe Card ----------------*/

export const EMPLOYER_STRIPE_CARD_SUCCESS = 'employer_stripe_card_success';
export const EMPLOYER_STRIPE_CARD_FAIL = 'employer_stripe_card_fail';

export const EMPLOYER_STRIPE_EMAIL_SUCCESS = 'employer_stripe_email_success';
export const EMPLOYER_STRIPE_EMAIL_FAIL = 'employer_stripe_email_fail';

/* -------------------- Client Signup ------------------*/

export const CLIENT_SIGNUP_SAVE = "client_signup_save";
export const CLIENT_SIGNUP_SAVE_SUCCESS = "client_signup_save_success";
export const CLIENT_SIGNUP_SAVE_FAIL = "client_signup_save_fail";

export const CLIENT_SIGNUP_RESUME = "client_signup_resume";
export const CLIENT_SIGNUP_RESUME_SUCCESS = "client_signup_resume_success";
export const CLIENT_SIGNUP_RESUME_FAIL = "client_signup_resume_fail";

export const CLIENT_UPDATE_APPLICATION_INPUT = "client_update_application_input";
export const CLIENT_UPDATE_APPLICATION = "client_update_application";

/* -------------------- Partner Signup ------------------*/

export const UPDATE_PARTNER_SIGNUP_DATA = 'update_partner_signup_data';
export const UPDATE_PARTNER_SIGNUP_INPUT = 'update_partner_signup_input';
export const UPDATE_PARTNER_SIGNUP_LICENSE_INPUT = 'update_partner_signup_license_input';
export const TOGGLE_PARTNER_LICENSE_PROVINCES = 'toggle_partner_license_provinces'
export const EMPTY_PARTNER_LOCAL_STORAGE = 'empty_partner_local_storage';

export const VALIDATE_PARTNER_SIGNUP_LICENSE_INPUT = 'validate_partner_signup_license_input';
export const VALIDATE_PARTNER_SIGNUP_INPUT = 'validate_partner_signup_input';

export const PARTNER_VALIDATION_SUCCESS = 'partner_validation_success';
export const PARTNER_VALIDATION_FAIL = 'partner_validation_fail';
export const FORM_PARTNER_APPLICATION = 'form_partner_application';
export const PARTNER_APPLICATION_SUCCESS = 'partner_application_success';
export const PARTNER_APPLICATION_FAIL = 'partner_application_fail';
export const PARTNER_APPLICATION = 'partner_application';

export const PARTNER_APPLICATION_SERVER_FAIL = 'partner_application_server_fail';

/*----------------------- Report --------------------------*/
export const REPORT_UPDATE_DATA = 'report_update_data';

export const REPORT_CLEAR_DATA = 'report_clear_data';

export const REPORT_RESET_INPUT_DATA = 'report_reset_input_data';
export const REPORT_SET_DATA = 'report_set_data';
export const REPORT_APPEND_DATA = 'report_append_data';
export const REPORT_FETCH_DATA_FAIL = 'report_fetch_data_fail';
export const REPORT_SET_INPUT_DATA = 'report_set_input_data';

export const REPORT_CLAIM_INFO = 'report_claim_info';
export const REPORT_CLAIM_INFO_SUCCESS = 'report_claim_info_success';
export const REPORT_CLAIM_INFO_FAIL = 'report_claim_info_fail';

export const REPORT_SUMMARY_INFO = 'report_summary_info';
export const REPORT_SUMMARY_INFO_SUCCESS = 'report_summary_info_success';
export const REPORT_SUMMARY_INFO_FAIL = 'report_summary_info_fail';

export const REPORT_BALANCE_INFO = 'report_balance_info';
export const REPORT_BALANCE_INFO_FAIL = 'report_balance_info_fail';
export const REPORT_BALANCE_INFO_SUCCESS = 'report_balance_info_success';

export const REPORT_BUSINESS_CLAIM_INFO = 'report_business_claim_info';
export const REPORT_BUSINESS_CLAIM_INFO_SUCCESS = 'report_business_claim_info_success';
export const REPORT_BUSINESS_CLAIM_INFO_FAIL = 'report_business_claim_info_fail';

export const REPORT_CLAIM_DETAILS_INFO = 'report_claim_details_info';
export const REPORT_CLAIM_DETAILS_INFO_SUCCESS = 'report_claim_details_info_success';
export const REPORT_CLAIM_DETAILS_INFO_FAIL = 'report_claim_details_info_fail';

/* ---------------------- Claims  ---------------------*/
export const CLAIM_REQUEST = 'claim_request';
export const CLAIM_REQUEST_FAILED = 'claim_request_failed';
export const CLAIM_REQUEST_SUCCESS = 'claim_request_success';

export const CLAIM_ID_SET = 'claim_id_set';
export const CLAIM_STATUS_SET = 'claim_status_set';
export const CLAIM_TYPE_SET = 'claim_type_set';

export const CLAIM_CLEAR_ITEMS = 'claim_clear_items';

export const CLAIM_GET_CLAIM_DETAILS = 'claim_get_claim_details';
export const CLAIM_GET_CLAIM_DETAILS_FAILED = 'claim_get_claim_details_failed';
export const CLAIM_GET_CLAIM_DETAILS_SUCCESS = 'claim_get_claim_details_success';


export const CLAIM_GET_PENDING_CLAIMS = 'claim_get_pending_claims';
export const CLAIM_GET_PENDING_CLAIMS_FAILED = 'claim_get_pending_claims_failed';
export const CLAIM_GET_PENDING_CLAIMS_SUCCESS = 'claim_get_pending_claims_success';

export const CLAIM_GET_ID = 'claim_get_id';
export const CLAIM_GET_ID_FAILED = 'claim_get_id_failed';
export const CLAIM_GET_ID_SUCCESS = 'claim_get_id_success';

export const CLAIM_ITEM_ADD = 'claim_item_add';
export const CLAIM_ITEM_ADD_FAILED = 'claim_item_add_failed';
export const CLAIM_ITEM_ADD_SUCCESS = 'claim_item_add_success';

export const CLAIM_ITEM_REMOVE = 'claim_item_remove';
export const CLAIM_ITEM_REMOVE_FAILED = 'claim_item_remove_failed';
export const CLAIM_ITEM_REMOVE_SUCCESS = 'claim_item_remove_success';

export const CLAIM_STATE_CANCEL = 'claim_state_cancel';
export const CLAIM_STATE_CANCEL_FAILED = 'claim_state_cancel_failed';
export const CLAIM_STATE_CANCEL_SUCCESS = 'claim_state_cancel_success';

export const CLAIM_RESUME_SET_DETAILS = 'claim_resume_set_details';
export const CLAIM_RESUME_SET_DETAILS_FAILED = 'claim_resume_set_details_failed';
export const CLAIM_RESUME_SET_DETAILS_SUCCESS = 'claim_resume_set_details_success';

export const CLAIM_RECEIPT_ADD = 'claim_receipt_add';
export const CLAIM_RECEIPT_ADD_FAILED = 'claim_receipt_add_failed';
export const CLAIM_RECEIPT_ADD_SUCCESS = 'claim_receipt_add_success';

export const CLAIM_RECEIPT_REMOVE = 'claim_receipt_remove';
export const CLAIM_RECEIPT_REMOVE_FAILED = 'claim_receipt_remove_failed';
export const CLAIM_RECEIPT_REMOVE_SUCCESS = 'claim_receipt_remove_success';

export const CLAIM_SAVE = 'claim_save';
export const CLAIM_SAVE_FAILED = 'claim_save_failed';
export const CLAIM_SAVE_SUCCESS = 'claim_save_success';

export const CLAIM_SUBMIT = 'claim_submit';
export const CLAIM_SUBMIT_FAILED = 'claim_submit_failed';
export const CLAIM_SUBMIT_SUCCESS = 'claim_submit_success';

export const CLAIM_UPDATE_PATIENTS_SUCCESS = 'claim_update_patients_success';

export const CLAIM_AUDIT_UPLOAD_SUBMIT = 'claim_audit_upload_submit';
export const CLAIM_AUDIT_UPLOAD_SUBMIT_FAILED = 'claim_audit_upload_submit_failed';
export const CLAIM_AUDIT_UPLOAD_SUBMIT_SUCCESS = 'claim_audit_upload_submit_success';

export const CLAIM_CANCEL = 'claim_cancel';
